if (!customElements.get('swiper-image-header-button')) {
    customElements.define(
        'swiper-image-header-button',
        class SwiperImageHeaderButton extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper');
            }

            connectedCallback() {
                const pagination = this.querySelector('.swiper-pagination');
                const prevButton = this.querySelector('.swiper-button-prev');
                const nextButton = this.querySelector('.swiper-button-next');
                this.swiperInstance = new Swiper(this.swiperEl, {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                    loop: true,
                    loopedSlides: 5,
                    // loopAdditionalSlides: 5,
                    // pagination: {
                    //     el: pagination,
                    //     clickable: true,
                    // },
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.1,
                            spaceBetween: 15,
                            loop: true,
                            loopedSlides: 5,
                        },
                        1001: {
                            slidesPerView: 2.5,
                            spaceBetween: 30,
                            loop: true,
                            loopedSlides: 5,
                        },
                    }
                });
            }

            disconnectedCallback() {
            }
        }
    );
}
